import type { FaireProductEntity } from "../../entity_types/product";

export const p_eshxvr2adj: FaireProductEntity = {
  token: "p_eshxvr2adj",
  type: "product",
  name: "Dog Days Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a8bffe19495a05c1c2c39a5f8fc1627a91d5d8eb23694785b6b68c89ff016f4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d88d3567cda55da5dfee56cddd203bef43008025906a7effd3ff75479497e03.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:12.755Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
